import React from "react";

const STYLE_VARS = {
  draft: ["--st-pending-fg", "--st-pending-bg", "--st-pending-bd"],
  issued_for_information: ["--st-pending-fg", "--st-pending-bg", "--st-pending-bd"],
  issued_for_review: ["--st-in-design-fg", "--st-in-design-bg", "--st-in-design-bd"],
  issued_for_planning: ["--st-planning-fg", "--st-planning-bg", "--st-planning-bd"],
  issued_for_building_control: ["--st-bc-fg", "--st-bc-bg", "--st-bc-bd"],
  superseded: ["--st-superseded-fg", "--st-superseded-bg", "--st-superseded-bd"],
  final: ["--st-complete-fg", "--st-complete-bg", "--st-complete-bd"],
};

const LABELS = {
  draft: "Draft",
  issued_for_information: "For info",
  issued_for_review: "For review",
  issued_for_planning: "For planning",
  issued_for_building_control: "For BC",
  superseded: "Superseded",
  final: "Final",
};

export const RevisionBadge = ({ status, revision, drawingNumber }) => {
  const [fg, bg, bd] = STYLE_VARS[status] || STYLE_VARS.draft;
  const isSuperseded = status === "superseded";
  // "For review" is intentionally not shown — it never gets kept up-to-date
  // by the practice and clutters the UI. The literal still exists in the
  // backend so historical data renders, just with no status chip.
  const hideStatusChip = status === "issued_for_review";
  return (
    <div className="flex items-center gap-2" data-testid="revision-badge">
      {drawingNumber && (
        <span className="font-mono text-[11px] text-[color:var(--atech-text-dim)]">
          {drawingNumber}
          {revision && <span className="text-[color:var(--atech-copper)]"> · Rev {revision}</span>}
        </span>
      )}
      {status && !hideStatusChip && (
        <span
          className={`inline-flex items-center px-2 py-0.5 rounded-[2px] text-[10px] uppercase tracking-[0.14em] border ${isSuperseded ? "line-through" : ""}`}
          style={{
            color: `var(${fg})`,
            backgroundColor: `var(${bg})`,
            borderColor: `var(${bd})`,
          }}
        >
          {LABELS[status] || status}
        </span>
      )}
    </div>
  );
};

export default RevisionBadge;
